import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

import queryString from "query-string"

/**
 * @param queryParams {object}
 * @param queryParams.person {string|string[]} NOTE: REQUIRED to be provided and assigned to self only
 * @param [queryParams.org] {string|string[]}
 * @param [queryParams.project] {string|string[]}
 * @param [queryParams.permission] {number|number[]}
 * @param [queryParams.isProjectManager] {boolean}
 * @param [queryParams.isProgramManager] {boolean}
 * @param [queryParams.tags] {string|string[]}
 * @param [queryParams.select] {string|string[]}
 * @param [queryParams.limit] {number}
 * @return {Promise<*>}
 */
export function getMissionPeople(queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/missions/people?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * @param [queryParams] {object}
 * @param [queryParams.org] {string|string[]}
 * @param [queryParams.project] {string|string[]}
 * @param [queryParams.permission] {number|number[]}
 * @param [queryParams.isProjectManager] {boolean}
 * @param [queryParams.isProgramManager] {boolean}
 * @param [queryParams.tags] {string|string[]}
 * @param [queryParams.limit] {number}
 * @return {Promise<*>}
 */
export function getMyMissionPeopleLite(queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/missions/people/me/lite?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

export function getMissionIdsByPerson(queryParams = {}) {
    const qs = queryString.stringify(queryParams)

    return api
        .get(`/v2/missions/people/person/lite?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
